import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'
import withStyles from '@material-ui/core/styles/withStyles'
import CssBaseline from '@material-ui/core/CssBaseline'
import ErrorRed from '../assets/error_red.png'
import Reservation from '../modules/reservation'
import Properties from '../modules/properties'
import { withTranslate } from 'react-redux-multilingual'
import CustomAppBar from './CustomAppBar'
import Loading from './Loading'
import Checkin from './Checkin'
import Error from './Error'
import LocatorInputCard from './home/LocatorInputCard'
import ReservationSummaryCard from './home/ReservationSummaryCard'
import FindPropertyCard from './home/FindPropertyCard'
import FindReservationByEmailCard from './home/FindReservationByEmailCard'
import 'typeface-roboto'

class Home extends React.Component {
  state = {
    loading: this.props.loading,
    isShowLink: false,
    isFindReservation: false,
    isFindStart: true,
    endPointFindReservation: '',
    reservationId: '',
    connectPropertyId: null,
    reservationList: [],
    reservationLoaded: false,
    connectDefaultLanguage: 'en',
    error: false,
    errorText: '',
    expanded: this.props.bookingId && this.props.propertyId,
    isFindProperty: false,
    docheckin: false,
    checkin: null,
    searchName: '',
    searchEmail: '',
    propertyInfo: {
      property_name: '',
      contact_email: '',
      address: '',
      phone: '',
      logo: ErrorRed
    },
    bookingInfo: {
      check_in_date: '',
      check_out_date: '',
      totalGuests: 0,
      rooms: []
    },
    dateIn: new Date(),
    dateOut: new Date(),
    externalData: null,
    selectedRoom: '',
    selectedRoomID: null,
    selectedHospede: -1,
    totalHospedes: 0,
    findProperties: [],
    errorMessage: null,
    fulfilled: false
  }

  _findInProgress = false

  constructor(props) {
    super(props)

    this.findReservation = this.findReservation.bind(this)
    this.gotoCheckin = this.gotoCheckin.bind(this)
  }

  handleChange = (name) => (event) => {
    const value = event.target.value
    this.setState({ [name]: value })
  }

  async componentDidMount() {
    if (process.env.hasOwnProperty('REACT_APP_LOCATOR_CODE')) {
      this.setState({ reservationId: process.env.REACT_APP_LOCATOR_CODE })
    }

    if (this.props.propertyId && this.props.bookingId) {
      const defaultLocale = this.props.Intl.locale
      const checkin = await Reservation.getCheckin(defaultLocale)

      if (!checkin) {
        this.setState({ externalData: '404' })
      } else if (checkin.status) {
        this.setState({
          checkin: checkin.result,
          propertyInfo: checkin.result.propertyInfo,
          bookingInfo: checkin.result.bookingInfo,
          loading: false,
          dateIn: checkin.result.bookingInfo.formatted_check_in_date,
          dateOut: checkin.result.bookingInfo.formatted_check_out_date
        })
      } else {
        this.setState({ loading: false })
        if (checkin.result.errors[0]) {
          this.setState({
            fulfilled: !!checkin.result.fulfilled,
            errorMessage: checkin.result.errors[0]
          })
        }
      }
    }

    const { pathname } = window.location

    if (String(pathname).length >= 2) {
      const _pathname = String(pathname).replace('/', '')
      this.setState({ loading: true })
      const connect = await Properties.connectProperty(_pathname)
      if (connect.status === true) {
        if (localStorage.getItem('hqbeds@property') !== _pathname) {
          localStorage.removeItem('hqbeds@property')
        }

        if (!localStorage.getItem('hqbeds@property')) {
          let _locale = 'en'
          // eslint-disable-next-line default-case
          switch (connect.result.default_language) {
            case 'pt-br':
              _locale = 'pt'
              break
            case 'es':
              _locale = 'es'
              break
          }
          this.props.setLocale(_locale)
          localStorage.setItem('hqbeds@property', _pathname)
        }

        this.setState({
          isShowLink: true,
          loading: false,
          isFindReservation: false,
          isFindProperty: false,
          isFindStart: true,
          connectPropertyId: connect.result.propertyId,
          endPointFindReservation: connect.result.api_endpoint,
          connectDefaultLanguage:
            this.props.Intl.locale === 'en'
              ? this.props.Intl.locale
              : connect.result.default_language
        })
      } else {
        this.setState({ loading: false })
      }
    }
  }

  render() {
    const { classes } = this.props
    const {
      isFindProperty,
      isFindStart,
      isFindReservation,
      dateIn,
      dateOut,
      isShowLink,
      errorMessage,
      fulfilled,
      expanded,
      propertyInfo,
      bookingInfo,
      reservationId,
      error,
      errorText,
      searchEmail,
      reservationLoaded,
      reservationList,
      findProperties,
      loading,
      docheckin
    } = this.state

    if (errorMessage) {
      return <Error fulfilled={fulfilled} message={errorMessage} hideNext={true} />
    }

    if (docheckin) {
      return (
        <Checkin
          roomName={this.state.selectedRoom}
          hospede={this.state.selectedHospede}
          totalGuests={this.state.totalHospedes}
          roomId={this.state.selectedRoomID}
        />
      )
    }

    return (
      <>
        <Loading visible={loading} />
        <div style={{ display: loading ? 'none' : 'block' }}>
          <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <CustomAppBar />
            <main className={classes.layout}>
              {isFindStart && !expanded && (
                <LocatorInputCard
                  reservationId={reservationId}
                  error={error}
                  errorText={errorText}
                  showFindPropertyLink={isShowLink}
                  onChangeReservationId={this.handleChange('reservationId')}
                  onKeyPress={this.onKeyPress}
                  onSubmit={this.findReservation}
                  onClickFindProperty={this.gotoFindProperty}
                />
              )}
              {isFindStart && expanded && (
                <ReservationSummaryCard
                  expanded={expanded}
                  propertyInfo={propertyInfo}
                  bookingInfo={bookingInfo}
                  dateIn={dateIn}
                  dateOut={dateOut}
                  onSelectRoom={this.gotoCheckin}
                />
              )}
              {isFindProperty && (
                <FindPropertyCard
                  properties={findProperties}
                  onSearchInput={this.handleChangeFindProperty}
                  onSelectProperty={this.handleChangeSelectProperty}
                />
              )}
              {isFindReservation && (
                <FindReservationByEmailCard
                  searchEmail={searchEmail}
                  error={error}
                  errorText={errorText}
                  reservationLoaded={reservationLoaded}
                  reservationList={reservationList}
                  onChangeSearchEmail={this.handleChange('searchEmail')}
                  onKeyPress={this.onKeyPress}
                  onSubmit={this.gotoReservation}
                  onSelectReservation={this.handleClickReservation}
                />
              )}
            </main>
          </MuiThemeProvider>
        </div>
      </>
    )
  }

  handleClickReservation = (row) => {
    this.setState({ loading: true })
    try {
      window.open(`${row.checkin_online_url}`, '_self')
    } catch (e) {
      this.setState({ loading: false })
    }
  }

  gotoReservation = async () => {
    this.setState({ loading: true })
    try {
      const info = await Properties.findReservationByInfo(
        this.state.endPointFindReservation,
        {
          query: this.state.searchEmail,
          propertyId: this.state.connectPropertyId,
          language:
            this.props.Intl.locale === 'en'
              ? this.props.Intl.locale
              : this.state.connectDefaultLanguage
        }
      )
      const { status, result } = info

      if (status === true) {
        this.setState({
          reservationLoaded: true,
          reservationList: result.reservations,
          loading: false
        })
      } else {
        this.setState({ loading: false })
      }
    } catch (e) {
      this.setState({ loading: false })
    }
  }

  handleChangeSelectProperty = async (property) => {
    this.setState({ loading: true })

    const connect = await Properties.connectProperty(property.id)

    if (connect.status === true) {
      this.setState({
        loading: false,
        isFindReservation: true,
        isFindProperty: false,
        isFindStart: false,
        connectPropertyId: connect.result.propertyId,
        endPointFindReservation: connect.result.api_endpoint,
        connectDefaultLanguage:
          this.props.Intl.locale === 'en'
            ? this.props.Intl.locale
            : connect.result.default_language
      })
    }
  }

  handleChangeFindProperty = async (event) => {
    const value = event.target.value
    if (value.length < 3) {
      this.setState({ findProperties: [] })
      return
    }
    if (this._findInProgress) return

    this._findInProgress = true
    try {
      const property = await Properties.findProperty(value)
      if (property.status === true) {
        this.setState({ findProperties: property.result.propertyList })
      }
    } finally {
      this._findInProgress = false
    }
  }

  onKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      this.findReservation()
    }
  }

  findReservation = () => {
    const reservationId = this.state.reservationId
    const defaultLocale = this.props.Intl.locale

    if (reservationId === '') {
      this.setState({
        error: true,
        errorText: this.props.translate('localizadorError')
      })
      return
    }

    this.setState({ loading: true })

    Reservation.findReservation({ reservationId }).then((response) => {
      if (!response.status) {
        this.setState({
          error: true,
          errorText: this.props.translate('localizadorNotFound'),
          loading: false
        })
        return
      }

      const [, qs = ''] = String(response.result.edp).split('?')
      const urlQuery = Object.fromEntries(new URLSearchParams(qs))

      sessionStorage.setItem('url', response.result.base)
      sessionStorage.setItem('locale', defaultLocale)
      sessionStorage.setItem('bookingId', urlQuery.bookingId)
      sessionStorage.setItem('propertyId', urlQuery.propertyId)

      Reservation.getCheckin(defaultLocale).then((checkin) => {
        if (!checkin || !checkin.status) {
          this.setState({
            error: true,
            errorText: this.props.translate('localizadorNotFound'),
            loading: false
          })
          return
        }

        try {
          this.setState({
            checkin: checkin.result,
            propertyInfo: checkin.result.propertyInfo,
            bookingInfo: checkin.result.bookingInfo,
            externalData: '',
            expanded: true,
            error: false,
            errorText: '',
            loading: false,
            docheckin: false,
            dateIn: checkin.result.bookingInfo.formatted_check_in_date,
            dateOut: checkin.result.bookingInfo.formatted_check_out_date
          })
        } catch (ex) {
          this.setState({
            error: true,
            errorText: this.props.translate('localizadorNotFound'),
            loading: false
          })
        }
      })
    })
  }

  gotoFindProperty = async () => {
    this.setState({ loading: true })
    if (this.state.connectPropertyId !== null) {
      this.setState({
        loading: false,
        isFindStart: false,
        isFindProperty: false,
        isFindReservation: true
      })
    } else {
      this.setState({
        loading: false,
        isFindStart: false,
        isFindProperty: true,
        isFindReservation: false
      })
    }
  }

  gotoCheckin = (roomName, totalGuests, emptyGuests, roomId) => {
    const guest = totalGuests - emptyGuests + 1
    this.setState({
      selectedRoomID: roomId,
      selectedRoom: roomName,
      selectedHospede: guest,
      totalHospedes: totalGuests,
      docheckin: true
    })
  }
}

const styles = (theme) => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(4))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  }
})

const theme = createTheme({
  typography: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    useNextVariants: true
  },
  palette: {
    primary: { main: '#455A64' },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      contrastText: '#ffcc00'
    }
  }
})

const mapStateToProps = (state) => ({ ...state })

const mapDispatchToProps = (dispatch) => ({
  setLocale: (locale) => dispatch({ type: 'SET_LOCALE', locale })
})

Home.propTypes = {
  classes: PropTypes.object.isRequired
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(withTranslate(Home))
